// React
import { useEffect, useState } from "react";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import {
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormControlLabel,
  Switch,
} from "@mui/material";

import RestartAltIcon from "@mui/icons-material/RestartAlt";

import Stack from "@mui/material/Stack";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";

function formatDate(date) {
  const today = date.split("-");
  const dd = today[0];

  const mm = parseInt(today[1], 10) - 1;
  const yyyy = today[2];

  return new Date(yyyy, mm, dd);
}

const columns = [
  { Header: "Appartenir", accessor: "belong", align: "center" },
  { Header: "Titre", accessor: "title", align: "left" },
  { Header: "Resumé", accessor: "resume", align: "left" },
  { Header: "Prix", accessor: "price", align: "center" },
];

function LessonsList({ listId, handleChecked }) {
  const lessons = useSelector((state) => state.lesson.allLessons);
  const [authorList, setAuthorList] = useState([]);
  const [dataAfterSearch, setDataAfterSearch] = useState([]);
  const courses = useSelector((state) => state.course.allCourses);
  const users = useSelector((state) => state.user.allUsers);

  const [fields, setFields] = useState({
    course: { value: "Aucune" },
    user: { value: "Aucune" },
    titleORresume: { value: "" },
    dateDebut: { value: null },
    dateFin: { value: null },
  });
  const filterAuthor = () => {
    let utilisator = users;
    utilisator = utilisator.filter((u) => u.roles.includes("ROLE_AUTHOR"));
    return utilisator;
  };

  useEffect(() => {
    setAuthorList(filterAuthor());
  }, [users]);

  const resetSearch = () => {
    setFields({
      access: { value: "Aucune" },
      course: { value: "Aucune" },
      user: { value: "Aucune" },
      titleORresume: { value: "" },
      dateDebut: { value: null },
      dateFin: { value: null },
    });
    setDataAfterSearch(lessons);
  };
  const filterData = (courseParam, userParam, titleORresume, dateDebut, dateFin) => {
    let data = lessons;

    data = data.filter((l) => l.price > 0);
    data = data.filter((l) => l.status === "Validé");
    if (courseParam !== "Aucune") data = data.filter((l) => l.course.wording.includes(courseParam));
    if (userParam !== "Aucune")
      data = data.filter((l) => l.users.some((user) => user.fullname.includes(userParam)));
    if (titleORresume !== "")
      data = data.filter(
        (l) =>
          l.title.toLowerCase().includes(titleORresume.toLowerCase()) ||
          l.resume.toLowerCase().includes(titleORresume.toLowerCase())
      );
    if (dateDebut !== null) data = data.filter((l) => dateDebut <= formatDate(l.createdAt));
    if (dateFin !== null) data = data.filter((l) => formatDate(l.createdAt) <= dateFin);

    return data;
  };

  useEffect(() => {
    setDataAfterSearch(
      filterData(
        fields.course.value,
        fields.user.value,
        fields.titleORresume.value,
        fields.dateDebut.value,
        fields.dateFin.value
      )
    );
  }, [lessons]);

  const handleChangeSearch = (name, value) => {
    setFields((f) => ({
      ...f,
      [name]: { value },
    }));
    setDataAfterSearch(
      filterData(
        name === "course" ? value : fields.course.value,
        name === "user" ? value : fields.user.value,
        name === "titleORresume" ? value : fields.titleORresume.value,
        name === "dateDebut" ? value : fields.dateDebut.value,
        name === "dateFin" ? value : fields.dateFin.value
      )
    );

    if (
      (name === "course" ? value : fields.course.value) === "Aucune" &&
      (name === "user" ? value : fields.user.value) === "Aucune" &&
      (name === "titleORresume" ? value : fields.titleORresume.value) === "" &&
      (name === "dateDebut" ? value : fields.dateDebut.value) === null &&
      (name === "dateFin" ? value : fields.dateFin.value) === null
    )
      setDataAfterSearch(lessons);
  };

  const rows = dataAfterSearch.map((lesson) => ({
    belong: (
      <div style={{ maxWidth: 200 }}>
        <FormControlLabel
          control={
            <Switch
              name="showed"
              checked={listId.includes(lesson.id)}
              onChange={(e) => handleChecked(e, lesson.id)}
            />
          }
        />
      </div>
    ),
    title: (
      <div style={{ maxWidth: 200 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {lesson.title}
        </MDTypography>
      </div>
    ),
    resume: (
      <div style={{ maxWidth: 250 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {lesson.resume}
        </MDTypography>
      </div>
    ),
    price: (
      <div style={{ maxWidth: 250 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {`${lesson.price} toges`}
        </MDTypography>
      </div>
    ),
  }));

  return (
    <>
      <MDBox
        sx={{
          // display: "flex",
          // justifyContent: "flex-end",
          p: 1,
          m: 1,
        }}
      >
        <Stack
          // alignItems="center"
          justifyContent="center"
          direction={{ xs: "column", md: "row" }}
          spacing={1}
        >
          <div>
            <FormControl sx={{ m: 1, minWidth: 140 }} fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">
                Filtrer par Cours
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-Catégorie"
                id="demo-simple-select-Catégorie"
                name="course"
                value={fields.course.value}
                label="Filtrer par Cours"
                onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              >
                <MenuItem value="Aucune">Aucune</MenuItem>
                {courses.map((cr) => (
                  <MenuItem key={cr.id} value={cr.wording}>
                    {cr.wording}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div>
            <FormControl sx={{ m: 1, minWidth: 140 }} fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">
                Filtrer par auteur
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-auteur"
                id="demo-simple-select-auteur"
                name="user"
                value={fields.user.value}
                label="Filtrer par auteur"
                onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              >
                <MenuItem value="Aucune">Aucune</MenuItem>
                {authorList.map((user) => (
                  <MenuItem key={user.fullname} value={user.fullname}>
                    {user.fullname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={1} sx={{ width: "100%", ml: 1, my: 1 }} direction="row">
                <DesktopDatePicker
                  label="Date début"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateDebut.value}
                  onChange={(e) => handleChangeSearch("dateDebut", e)}
                  renderInput={(params) => (
                    <TextField
                      style={{ width: "inherit" }}
                      // onChange={(e) => {
                      //   if (e.target.value === "") setDataAfterSearch(lessons);
                      // }}
                      {...params}
                    />
                  )}
                />
                <DesktopDatePicker
                  label="Date fin"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateFin.value}
                  onChange={(e) => handleChangeSearch("dateFin", e)}
                  renderInput={(params) => (
                    <TextField
                      style={{ width: "inherit" }}
                      // onChange={(e) => {
                      //   if (e.target.value === "") setDataAfterSearch(lessons);
                      // }}
                      {...params}
                    />
                  )}
                />
              </Stack>
            </LocalizationProvider>
          </div>

          <div style={{ display: "inline-flex", alignItems: "center" }}>
            <TextField
              name="titleORresume"
              value={fields.titleORresume.value}
              sx={{ ml: 1, my: 1, minWidth: 140 }}
              onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              label="Titre ou résumée"
              id="outlined-size-small"
              fullWidth
            />
            <RestartAltIcon sx={{ m: 1 }} onClick={() => resetSearch()} />
          </div>
        </Stack>
      </MDBox>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
    </>
  );
}
LessonsList.propTypes = {
  listId: PropTypes.oneOfType([PropTypes.array]).isRequired,
  handleChecked: PropTypes.func.isRequired,
};

export default LessonsList;
